<template></template>

<script>
import { getAllUserGrayConfig, colseUserGrayConfig, CloseScenes } from '@/utils/getAllGrayConfig.js'
var opacityFlag = false
export default {
  name: 'InsuranceBtn',
  mounted() {
    this.checkShowBtn()
  },
  data() {
    return {
      isShowHideDialog: false
    }
  },
  methods: {
    // 去除当前iframe和其他iframe中存在的保险图标
    removeAllFloatBtn() {
      var allIframe = top.document.getElementsByTagName('iframe')
      for (let index = 0; index < allIframe.length; index++) {
        var element =
          allIframe[index] &&
          allIframe[index].contentDocument &&
          allIframe[index].contentDocument.getElementsByClassName('float-btn-insurance') &&
          allIframe[index].contentDocument.getElementsByClassName('float-btn-insurance')[0]
        if (element) {
          $(element).hide()
        }
      }
    },
    showDelConfirm() {
      var _this = this
      this.isShowHideDialog = true
      this.$LqConfirm('是否隐藏浮动入口，今后不再提示？', {
        confirmButtonText: '永久隐藏',
        cancelButtonText: '暂时折叠'
      })
        .then(result => {
          _this.isShowHideDialog = false
          colseUserGrayConfig(CloseScenes.insureFloatBtn)
          _this.removeAllFloatBtn()
        })
        .catch(err => {
          _this.isShowHideDialog = false
          $('.insurance-icon-tip').css({
            opacity: 0,
            display: 'none'
          })
          opacityFlag = false
          $('.float-btn-insurance').trigger('mouseleave')
          $('#insurance-icon-close').hide()
          $('.float-btn-insurance').css({
            width: '35px',
            'background-image': 'url("https://imagecdn.ymm56.com/ymmfile/static/resource/79f23435-3951-4b9f-825d-2dbe0d9d60f7.png")'
          })
        })
    },
    checkShowBtn() {
      var checkRes = getAllUserGrayConfig()
      if (checkRes && !checkRes.insurancePopShow) {
        return
      }
      this.insurance_btn()
      // 设置悬浮入口的初始位置
      this.setWxServiceBtnPosition()
    },
    insurance_btn() {
      var that = this
      var menuDisplay = false
      var flag = true
      var timer
      var html = []
      html = `<div class="float-btn-insurance" id="insurance-icon" style="background-size: 100% 100%;background-repeat: no-repeat;background-image: url(https://imagecdn.ymm56.com/ymmfile/static/resource/79f23435-3951-4b9f-825d-2dbe0d9d60f7.png)">
        <div class="insurance-icon-tip" id="insurance-icon-tip">
        </div>
        <img id="insurance-icon-close" src="https://imagecdn.ymm56.com/ymmfile/static/resource/97e8b023-b2e4-4f85-b98f-742f916ea86b.png" />
        </div>
      </div>`
      $('body').append(html)

      var insuranceConsultation =
        JSON.parse(localStorage.getItem('configMap') || '{}') && JSON.parse(localStorage.getItem('configMap') || '{}').insuranceConsultation
      document.getElementById('insurance-icon-tip').innerText = insuranceConsultation.title || ''

      iconBorder()
      //图标移动方法
      $('.float-btn-insurance').ligerDrag &&
        $('.float-btn-insurance').ligerDrag({
          proxy: false,
          clickDelay: 200,

          //开始移动事件
          onStartDrag: function () {
            //移动状态下不弹出菜单组件
            flag = false
          },
          //移动结束事件
          onStopDrag: function (start, end) {
            var rightDistance = document.documentElement.clientWidth
            var btn = $('.float-btn-insurance').offset().left
            var btnTop = $('.float-btn-insurance').offset().top
            var width = $('.float-btn-insurance').width()
            setTimeout(function () {
              flag = true
            }, 300)

            //移动结束后判断是否靠浏览器右边边界
            if (btn + width + 5 >= rightDistance) {
              //靠近边界
              // $('.float-btn-insurance').css({
              //     left:rightDistance-40*0.6,
              //     opacity:'.6'
              // })
            } else {
              //移出边界了,图标让正常使用
              $('.float-btn-insurance').css({
                opacity: '1'
              })
              flag = true
              that.setAllFloatPosition({
                clientX: btn,
                clientY: btnTop
              })
            }
          }
        })

      $()
      //鼠标移入图标事件
      $('.float-btn-insurance').mouseover(function () {
        if (flag) {
          //0.5秒后弹出菜单组件
          timer = setTimeout(function () {
            //移动状态下不弹出菜单组件
            if (!flag) {
              clearTimeout(timer)
              return
            }
            $('#insurance-icon-close').show()
            $('.float-btn-insurance').css({
              width: '137px',
              'background-image': 'url("https://imagecdn.ymm56.com/ymmfile/static/resource/a8e8d8da-7431-4dea-a6e4-ecc047ee5da5.png")'
            })
          }, 200)
        }

        if (!menuDisplay) {
          $('.float-btn-insurance').css({
            opacity: '1'
          })
          menuDisplay = true
          flag = true
        }
      })

      // 鼠标移开图标事件
      $('.float-btn-insurance').mouseleave(function () {
        if (menuDisplay && flag && !that.isShowHideDialog) {
          $('#insurance-icon-close').hide()
          $('.float-btn-insurance').css({
            width: '35px',
            'background-image': 'url("https://imagecdn.ymm56.com/ymmfile/static/resource/79f23435-3951-4b9f-825d-2dbe0d9d60f7.png")'
          })
          clearTimeout(timer)
        }
      })

      //窗口大小改变
      $(window).resize(function () {
        winChange()
      })

      //浏览器窗口大小改变后的回调
      function winChange() {
        var rightDistanceR = document.documentElement.clientWidth
        var btnR = $('.float-btn-insurance').offset().left
        if (btnR + 40 >= rightDistanceR) {
          //贴近右边浏览器边界时
          menuDisplay = false
        } else if (btnR > rightDistanceR) {
          //图标移动距离大于浏览器大小时
          menuDisplay = false
        } else {
          //图标已被移动出来
          $('.float-btn-insurance').css({
            opacity: '1'
          })
          menuDisplay = true
          //menuDisplay ，图标移动出来后，停留在图标上可以让图标弹出菜单组件
        }
      }

      //隐藏图标函数
      function iconBorder() {
        var width = $('.float-btn-insurance').width()
        $('.float-btn-insurance').css({
          right: '60px'
        })
      }

      $('.float-btn-insurance').on('click', function (e) {
        // 点击的是关闭按钮
        if (e && e.target && e.target.id && e.target.id == 'insurance-icon-close') {
          that.showDelConfirm()
          return
        }
        if (!flag) {
          e.preventDefault()
          e.stopPropagation()
          return false
        } else {
          window.lib && window.lib.track.tap('click_info_insuranceAdvisor2', 'Main', {
            pageName: 'lanqiao_saas_home'
          })
          if (!opacityFlag) {
            $('.insurance-icon-tip').css({
              opacity: 1,
              display: 'block'
            })
            opacityFlag = true
          } else {
            $('.insurance-icon-tip').css({
              opacity: 0,
              display: 'none'
            })
            opacityFlag = false
          }
        }
      })
    },
    setWxServiceBtnPosition() {
      const floatBtnEntrancePosition = JSON.parse(top.window.sessionStorage.getItem('floatBtnEntrancePosition'))
      if (floatBtnEntrancePosition) {
        $('.float-btn-insurance').css({
          left: floatBtnEntrancePosition.left,
          top: floatBtnEntrancePosition.top
        })
      }
    },
    setAllFloatPosition(end) {
      top.window.sessionStorage.setItem(
        'floatBtnEntrancePosition',
        JSON.stringify({
          left: end.clientX,
          top: end.clientY
        })
      )
      var allIframe = top.document.getElementsByTagName('iframe')
      for (let index = 0; index < allIframe.length; index++) {
        const element =
          allIframe[index] &&
          allIframe[index].contentDocument &&
          allIframe[index].contentDocument.getElementsByClassName('float-btn-insurance') &&
          allIframe[index].contentDocument.getElementsByClassName('float-btn-insurance')[0]
        if (element && end) {
          $(element).css({
            left: end.clientX,
            top: end.clientY
          })
        }
      }
    }
  }
}
</script>

<style></style>
